import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "../../Pages/Login/Login.css";
import logo from "../../Assets/img/Logo_Image.svg";
import API from "../Service/Baseservice";

const Login = () => {
    const navigate = useNavigate();

    const [emailId, setEmailId] = useState("");
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState({ email: "", password: "", general: "" });
    const [showPwd, setShowPwd] = useState(false);

    const togglepwd = () => setShowPwd(!showPwd);

    const loginhandleSubmit = (event) => {
        event.preventDefault();


        let formErrors = { email: "", password: "", general: "" };
        let valid = true;

        if (!emailId) {
            formErrors.email = "Email is required";
            valid = false;
        }

        if (!password) {
            formErrors.password = "Password is required";
            valid = false;
        }

        if (!valid) {
            setErrors(formErrors);
            return;
        }


        setErrors({ email: "", password: "", general: "" });

        API.post("asra_admin/login", { email: emailId, password })
            .then((res) => {
                if (res.data.success === true) {
                    sessionStorage.setItem("user", JSON.stringify(res.data.data.user));
                    sessionStorage.setItem("isAdminLoggedIn", "true"); 
                    navigate("/admin");
                }
                else {

                    let backendErr = res.data.error;

                    if (backendErr?.email) {
                        setErrors((prev) => ({ ...prev, email: backendErr.email }));
                    }
                    else if (backendErr?.password) {
                        setErrors((prev) => ({ ...prev, password: backendErr.password }));
                    }
                    else {
                        setErrors((prev) => ({ ...prev, general: res.data.message || "Login failed" }));
                    }
                }
            })
            .catch(() => {
                setErrors((prev) => ({ ...prev, general: "Server error. Please try again." }));
            });
    };

    return (
        <div>
            <main className="inner-page">
                <div className="col-lg-4 card loginBlock">
                    <div className="dealar-login">
                        <img alt="Logo" src={logo} />
                    </div>

                    <form onSubmit={loginhandleSubmit}>
                        <h2 className="title">Login</h2>

                        <div className="email-login">
                            <div className="tbox">
                                <input
                                    className="textbox input-has-value"
                                    type="text"
                                    placeholder="Enter Email"
                                    value={emailId}
                                    onChange={(e) => setEmailId(e.target.value)}
                                />
                                <label className="login-label">Email</label>
                                <p className="form-input-error">{errors.email}</p>
                            </div>

                            <div className="tbox" style={{ position: "relative" }}>
                                <input
                                    className="textbox input-has-value"
                                    type={showPwd ? "text" : "password"}
                                    placeholder="Enter Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <label className="login-label">Password</label>

                                <button type="button" onClick={togglepwd}>
                                    <FontAwesomeIcon icon={showPwd ? faEyeSlash : faEye} />
                                </button>

                                <p className="form-input-error">{errors.password}</p>
                            </div>
                        </div>

                        {errors.general && (
                            <p className="form-input-error">{errors.general}</p>
                        )}

                        <div className="row">
                            <div className="col-lg-12 loginBtn">
                                <button type="submit" className="cta-btn">
                                    Log In
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </main>
        </div>
    );
};

export default Login;
